export default __webpack_public_path__ + "static/media/rhythm.646e128d.png";